export const RESET = 'EXSBVATRATE_LIST_RESET'
export const SET_ITEMS = 'EXSBVATRATE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBVATRATE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBVATRATE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBVATRATE_LIST_TOGGLE_LOADING'
